import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "components__gon-wrapper" }

import { ref } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'gon-wrapper',
  setup(__props) {

  const gon = ref(JSON.parse(JSON.stringify((window as any).gon)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { gon: gon.value })
  ]))
}
}

})